import { defineComponent as t, openBlock as n, createBlock as r, unref as p, mergeProps as d, withCtx as c, createElementVNode as l } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const h = /* @__PURE__ */ t({
  name: "IconWatch",
  __name: "IconWatch",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (u, e) => (n(), r(p(i), d(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M5.25 8.5A3.25 3.25 0 0 1 8.5 5.25h7a3.25 3.25 0 0 1 3.25 3.25v7a3.25 3.25 0 0 1-3.25 3.25h-7a3.25 3.25 0 0 1-3.25-3.25v-7M8.5 6.75A1.75 1.75 0 0 0 6.75 8.5v7a1.75 1.75 0 0 0 1.75 1.75h7a1.75 1.75 0 0 0 1.75-1.75v-7a1.75 1.75 0 0 0-1.75-1.75h-7",
          "clip-rule": "evenodd"
        }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M12 9a.75.75 0 0 1 .75.75v1.94l1.28 1.28a.75.75 0 1 1-1.06 1.06l-1.354-1.353a1.25 1.25 0 0 1-.366-.884V9.75A.75.75 0 0 1 12 9M8.175 2.855A1.25 1.25 0 0 1 9.36 2h5.28a1.25 1.25 0 0 1 1.185.855l.887 2.658-1.423.474-.83-2.487H9.541L8.71 5.987 7.289 5.513l.887-2.658m7.65 18.29A1.25 1.25 0 0 1 14.64 22H9.36a1.25 1.25 0 0 1-1.185-.855l-.887-2.658 1.424-.474L9.54 20.5h4.918l.83-2.487 1.423.474-.886 2.658",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
